import { render, staticRenderFns } from "./TestBankScopeSelector.vue?vue&type=template&id=65890d7f&scoped=true"
import script from "./TestBankScopeSelector.vue?vue&type=script&lang=js"
export * from "./TestBankScopeSelector.vue?vue&type=script&lang=js"
import style0 from "./TestBankScopeSelector.vue?vue&type=style&index=0&id=65890d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65890d7f",
  null
  
)

export default component.exports